import { Box } from '@mui/material';
import { ReactNode } from 'react';
import BorderLinearProgress from './BorderLinearProgress';

const LoadingState = ({ logo, hero, bottom = 48 }: { logo?: ReactNode; hero?: ReactNode; bottom?: number }) => (
  <Box
    sx={(theme) => ({
      width: '100%',
      textAlign: 'center',
      marginTop: theme.spacing(8),
    })}
  >
    {logo}
    <Box
      sx={(theme) => ({
        maxWidth: '200px',
        textAlign: 'center',
        margin: theme.spacing(4, 'auto'),
      })}
    >
      <BorderLinearProgress variant="indeterminate" sx={{ height: 10 }} />
    </Box>
    {hero && (
      <Box
        sx={(theme) => ({
          backgroundPosition: 'right bottom',
          position: 'absolute',
          left: 0,
          bottom: bottom,
          width: '100%',
          [theme.breakpoints.up('md')]: {
            display: 'none',
          },
        })}
      >
        {hero}
      </Box>
    )}
  </Box>
);

export default LoadingState;
